import { createFileRoute, Outlet } from '@tanstack/react-router'

import type { CrumbLoader } from '@/hook/use-breadcrumbs'

export const Route = createFileRoute('/_app/settings')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: 'Pengaturan',
    } satisfies CrumbLoader
  },
})

function RouteComponent() {
  return <Outlet />
}
